import {gql} from "graphql-tag";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const contactCenterFields = `
  id
  uniqueId
  institution {
    id
    institutionUniqueId
    institutionName
    institutionShortform
  }
  isSystemContact
  callPhone
  smsPhone
  schedules {
    id
    uniqueId
    weekday
    startTime
    endTime
  }
  socialMedia {
    id
    uniqueId
    platform
    title
    handle
    icon
    url
  }
`;

export const contactCenterFeweFields = `
  id
  uniqueId
  isSystemContact
  callPhone
  smsPhone
  socialMedia {
    id
    uniqueId
    platform
    title
    handle
    icon
    url
  }
`;


export const CREATE_CONTACT_CENTER = gql`
  mutation CreateContactCenterMutation($input: ContactCenterInput!) {
    createContactCenterMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${contactCenterFields}
      }
    }
  }
`;

export const UPDATE_CONTACT_CENTER = gql`
  mutation UpdateContactCenterMutation($input: ContactCenterInput!) {
    updateContactCenterMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${contactCenterFields}
      }
    }
  }
`;

export const DELETE_CONTACT_CENTER = gql`
  mutation DeleteContactCenterMutation($uniqueId: String!) {
    deleteContactCenterMutation(uniqueId: $uniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`;

export const GET_CONTACT_CENTERS = gql`
  query GetContentCenters {
    getContentCenters {
      ${baseResponseGraphqlField}
      data {
        ${contactCenterFields}
      }
    }
  }
`;

export const GET_CONTACT_CENTER_FEWER = gql`
  query GetContentCenters($filtering: ContactCenterFilteringInputObject) {
    getContentCenters(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${contactCenterFeweFields}
      }
    }
  }
`;


